<script lang="ts">
	import { onDestroy } from "svelte";
	import Formatted from "./common/Formatted.svelte";

	const {
		number,
		title,
		subtitle,
		isActive,
		duration,
	}: { number: number; title: string; subtitle: string; isActive: boolean; duration: number } = $props();

	let progress = $state(0);
	let interval: ReturnType<typeof setInterval>;

	const radius = 28;
	const circumference = 2 * Math.PI * radius;

	const tickRate = 100;
	const step = 100 / ((duration * 1000) / tickRate);

	function resetProgress(): void {
		clearInterval(interval);
		progress = 0;
		interval = setInterval(() => {
			progress += step;
			if (progress >= 100) {
				progress = 100;
				clearInterval(interval);
			}
		}, tickRate);
	}

	$effect(() => {
		if (isActive) {
			resetProgress();
		} else {
			clearInterval(interval);
			progress = 0;
		}
	});

	onDestroy(() => {
		clearInterval(interval);
	});
</script>

<div class="flex gap-3 md:gap-6 {isActive ? 'items-start' : 'items-center'}">
	<div class="relative w-16 h-16 min-w-16 min-h-16">
		<svg class="absolute top-0 left-0" width="64" height="64">
			<circle cx="32" cy="32" r={radius} stroke="#D7D7D7" stroke-width="2" fill="white" />
			{#if isActive}
				<circle
					cx="32"
					cy="32"
					r={radius}
					stroke="#0000FF"
					stroke-width="1"
					fill="none"
					stroke-dasharray={circumference}
					stroke-dashoffset={circumference * (1 - progress / 100)}
					stroke-linecap="round"
					transform="rotate(-90 32 32)"
					style="transition: stroke-dashoffset 0.1s linear;"
				/>
			{/if}
		</svg>
		<span
			class={`absolute inset-0 font-hubot flex items-center justify-center text-md/[1] md:text-lg/[1] font-light rounded-full ${isActive ? "text-zms-blue" : "text-zms-optical-black"} ${number === 1 ? "pr-0.5" : ""}`}
		>
			{number}
		</span>
	</div>

	<div class="flex flex-col mt-2 gap-2 md:gap-4">
		<span class="md:text-lg/[1.2] font-hubot text-md/[1.2] tracking-[-1%] text-zms-dark-blue font-medium">
			<Formatted text={title} />
		</span>
		{#if isActive}
			<span class="text-sm/[1.5] font-medium tracking-[-1%] text-zms-optical-black">
				<Formatted text={subtitle} />
			</span>
		{/if}
	</div>
</div>
